import { StyleSheet, Font } from '@react-pdf/renderer';

Font.register({
  family: 'Helvetica', // TODO: traer el tipo de fuente correcta
  fonts: [
    {
      src: 'https://fonts.gstatic.com/s/helvetica/v1/Bg3_AWfETx3eINQ0Yc5d7Ejg.woff2',
    },
    {
      src: 'https://fonts.gstatic.com/s/helvetica/v1/Bg3_AWfETx3eINQ0Yc5d7Ejg.woff2',
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: 'Helvetica',
    borderTop: '6px solid #006719',
    borderBottom: '6px solid #006719',
    lineHeight: 2,
    width: 399,
    textAlign: 'justify',
  },
  text: {
    fontSize: '11px',
    color: '#344054',
  },
  item: {
    fontSize: '11px',
    color: '#344054',
    flexDirection: 'row',
    textAlign: 'justify',
  },
  boldText: {
    fontWeight: 'bold',
  },
});
